export enum ILang {
  "en" = "en",
  "es" = "es",
  "sv" = "sv"
}
